export default __webpack_public_path__ + "static/media/eudonix.a7349a48.png";